import paths, { rootPaths } from './paths';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { getConfig } from '../config/getConfig';

// 환경 설정 가져오기
const config = getConfig();
const isK8s = config.IS_K8S;

// 각 routes에서 isEnabled는 해당 메뉴의 활성화 여부를 결정 (노출여부 결정 X)
export const DashRoutes = {
  label: '정 보',
  children: [
    {
      name: '대시보드',
      icon: 'chart-pie',
      active: true,
      to: rootPaths.root,
      isEnabled: !isK8s, // SaaS에서만 활성화
      isHidden: isK8s
    },
    {
      name: '회사정보',
      icon: faBuilding,
      active: true,
      to: paths.SiteInfo,
      isEnabled: true,
    },
  ]
};

export const AccountRoutes = {

  label: '계 정 관 리',
  children: [
    {
      name: '관리자',
      icon: 'chart-pie',
      active: true,
      to: paths.SiteAdminAccount,
      isEnabled: true,
    },
  ]
};

export const appRoutes = {
  label: '키 관 리',
  children: [
    {
      name: '인증키',
      icon: 'calendar-alt',
      to: paths.apikey,
      active: true,
      isEnabled: true,
    },
    {
      name: '공유키',
      icon: 'envelope-open',
      to: paths.encryptPublicKey,
      active: true,
      isEnabled: true,
    },
    {
      name: '암호키',
      icon: 'comments',
      to: paths.encryptKeyPolicy,
      active: true,
      isEnabled: true,
    }

  ]
};

export const pagesRoutes = {
  label: '모 니 터 링',
  children: [
    {
      name: '관리 로그',
      icon: 'flag',
      to: paths.logManage,
      active: true,
      isEnabled: true,
    },
    {
      name: '암복호화 로그',
      icon: 'flag',
      to: paths.logEncDec,
      active: true,
      isEnabled: !isK8s, // SaaS에서만 활성화
      isHidden: isK8s
    },
  ]
};

export const modulesRoutes = {
  label: '청 구',
  children: [
    {
      name: '청구 내역',
      active: true,
      to: paths.billing,
      icon: 'file-invoice-dollar'
    },
  ]
};

export const guideRoutes = {
  label: '배 포',
  labelDisable: isK8s,
  children: [
    {
      name: 'SDK 가이드',
      active: true,
      to: paths.apiGuide,
      icon: 'file-alt',
      isEnabled: !isK8s, // SaaS에서만 활성화
      isHidden: isK8s,
    },
    {
      name: 'SDK 배포',
      active: true,
      to: paths.SdkDownload,
      icon: 'file-alt',
      isEnabled: !isK8s, // SaaS에서만 활성화
      isHidden: isK8s
    },
  ]
};

// // 요금정책관리 메뉴 추가 (SaaS, k8s 둘 다)
// export const pricingRoutes = {
//   label: '요 금',
//   children: [
//     {
//       name: '요금정책관리',
//       active: true,
//       to: paths.pricingPolicy,
//       icon: 'dollar-sign',
//       isEnabled: true, // SaaS, k8s 둘 다 활성화
//     },
//   ]
// };

export default [
  DashRoutes,
  AccountRoutes,
  appRoutes,
  pagesRoutes,
  modulesRoutes,
  guideRoutes // SaaS에서만 보이도록 주석 해제
  // pricingRoutes // 요금정책관리 메뉴 추가
];
